module.exports = __webpack_public_path__ + "img/cbam-3.2802b0ec.png";